<template>
  <div class="be-wrapper be-login">
    <div class="be-content">
      <div class="main-content container-fluid">
        <div class="splash-container">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-body">
              <span class="splash-title xs-pb-20"><h3>АИС "Курортный сбор"</h3></span>
              <span class="splash-title xs-pb-20"><h3>Введите новый пароль</h3></span>
              <div class="form-group"
                   :class="{'has-error' : errors.has('password1') || errors.has('password2')}">
                <label class="control-label">Новый пароль*</label>
                <input v-validate="'required|min:8'" class="form-control"
                       data-vv-as="Новый пароль" :class="{'input': true, 'is-danger': errors.has('password1') }"
                       name="password1" ref="password1"
                       type="password" placeholder="Пароль" v-model="password1" autocomplete="on">
                <span v-show="errors.has('password1')" class="text-danger">{{ errors.first('password1') }}</span>
              </div>
              <div class="form-group">
                <label class="control-label">Подтвердите пароль*</label>
                <input v-validate="'required|confirmed:password1|min:8'" class="form-control"
                       data-vv-as="Подтвердите пароль"
                       :class="{'input': true, 'is-danger': errors.has('password2') }" name="password2"
                       type="password" placeholder="Подтвердите пароль" v-model="password2"
                       autocomplete="on">
                <span v-show="errors.has('password2')" class="text-danger">{{ errors.first('password2')
                  }}</span>
              </div>
              <div class="alert alert-danger" v-if="errorMessages" v-for="message in errorMessages">
                <p>{{ message }}</p>
              </div>
              <div class="form-group login-submit">
                <button class="btn btn-primary btn-xl" v-on:click="confirmPasswordReset()">Изменить мой пароль</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    props: ['uid', 'token'],
    data () {
      return {
        password1: null,
        password2: null,
        errorMessages: null
      }
    },
    methods: {
      confirmPasswordReset () {
        this.errors.clear()
        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.post('/api/rest-auth/password/reset/confirm/', {
              'new_password1': this.password1,
              'new_password2': this.password2,
              'uid': this.uid,
              'token': this.token
            }).then(
              (response) => {
                if (response.status === 200) {
                  this.$snotify.success('Пароль изменён на новый. Используйте email/пароль для входа в систему.', 'Успешно!')
                  this.$router.push({name: 'login'})
                }
              },
              (error) => {
                if (error.response.status === 400) {
                  for (let [key, value] of Object.entries(error.response.data)) {
                    this.errors.add(key, value[0], 'server')
                  }
                  this.errors.add(error.response.data)
                  this.errorMessages = error.response.data.new_password2
                } else if (error.response.status >= 400) {
                  this.errors = ['Ошибка!. Попробуйте позже.']
                }
              }
            )
          } else {
            this.errorMessages = ['Проверьте введенные данные!']
          }
        })
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/auth/ConfirmResetPassword.vue